
import { createClient } from "@sanity/client";

export const client = createClient({
  projectId: "9cs7vd2g", // find this at manage.sanity.io or in your sanity.json
  dataset: "production", // this is from those question during 'sanity init'
  useCdn: true,
  apiVersion: '2023-09-29',
});